var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { variant: "elevated" } },
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-container",
            { staticClass: "ml-n1" },
            [
              _c(
                "v-row",
                { attrs: { justify: "start" } },
                [
                  _c("v-col", { staticClass: "w-75" }, [
                    _vm._v(
                      "\n           SAML\n                              \n                              \n          "
                    ),
                    _vm.metadataExists
                      ? _c("span", { staticClass: "metadata" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.metadata.metadataUrl,
                              },
                            },
                            [_vm._v("Download SAML Metadata")]
                          ),
                        ])
                      : _c("span", { staticClass: "metadata" }, [
                          _vm._v(
                            "\n            Download SAML Metadata\n          "
                          ),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-container",
                { staticClass: "ml-n1" },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-75" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Service Provider Entity ID",
                              variant: "outlined",
                              readonly: "",
                            },
                            model: {
                              value: _vm.metadata.spEntityId,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "spEntityId", $$v)
                              },
                              expression: "metadata.spEntityId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-75" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Assertion Consumer Service URL",
                              variant: "outlined",
                              readonly: "",
                            },
                            model: {
                              value: _vm.metadata.acsUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "acsUrl", $$v)
                              },
                              expression: "metadata.acsUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-75" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Single Sign-On URL",
                              variant: "outlined",
                              rules: _vm.rules.required,
                            },
                            model: {
                              value: _vm.metadata.loginUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "loginUrl", $$v)
                              },
                              expression: "metadata.loginUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-75" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Single Sign-Out URL (optional)",
                              variant: "outlined",
                            },
                            model: {
                              value: _vm.metadata.logoutUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "logoutUrl", $$v)
                              },
                              expression: "metadata.logoutUrl",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-25" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Issuer (IDP Entity ID)",
                              variant: "outlined",
                              rules: _vm.rules.required,
                            },
                            model: {
                              value: _vm.metadata.entityId,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "entityId", $$v)
                              },
                              expression: "metadata.entityId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "w-75" },
                        [
                          _c("v-select", {
                            staticClass: "w-75",
                            attrs: {
                              label: "NameID policy format",
                              items: _vm.nameIdFormatItems,
                              rules: _vm.rules.required,
                              "item-text": "k",
                              "item-value": "v",
                            },
                            model: {
                              value: _vm.metadata.nameIdFormat,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "nameIdFormat", $$v)
                              },
                              expression: "metadata.nameIdFormat",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "w-25" },
                        [
                          _c(
                            "v-radio-group",
                            {
                              attrs: { inline: "", rules: _vm.rules.required },
                              model: {
                                value: _vm.metadata.loginBinding,
                                callback: function ($$v) {
                                  _vm.$set(_vm.metadata, "loginBinding", $$v)
                                },
                                expression: "metadata.loginBinding",
                              },
                            },
                            [
                              _c("v-radio", {
                                attrs: {
                                  label: "HTTP-POST",
                                  value:
                                    "urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-radio", {
                                attrs: {
                                  label: "HTTP-Redirect",
                                  value:
                                    "urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "w-25" },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Sign SAML Request" },
                            model: {
                              value: _vm.metadata.signAuthnRequest,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "signAuthnRequest", $$v)
                              },
                              expression: "metadata.signAuthnRequest",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "w-50" },
                        [
                          _c("v-select", {
                            staticClass: "w-75",
                            attrs: {
                              label: "Signature Algorithm",
                              items: _vm.signingAlgorithmItems,
                              rules: _vm.rules.required,
                              "item-text": "k",
                              "item-value": "v",
                            },
                            model: {
                              value: _vm.metadata.signingAlgorithm,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "signingAlgorithm", $$v)
                              },
                              expression: "metadata.signingAlgorithm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-textarea", {
                            staticClass: "cert-mono",
                            attrs: {
                              label: "Verification / Validation Certificate",
                              variant: "outlined",
                              rules: _vm.rules.required,
                              clearable: "",
                              "clear-icon": "mdi-close-circle",
                            },
                            model: {
                              value: _vm.metadata.verificationCert,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "verificationCert", $$v)
                              },
                              expression: "metadata.verificationCert",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Admin Group Mapping",
                              variant: "outlined",
                              placeholder: "vyopta_admin",
                            },
                            model: {
                              value: _vm.metadata.adminRoleMapping,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "adminRoleMapping", $$v)
                              },
                              expression: "metadata.adminRoleMapping",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "User Group Mapping",
                              variant: "outlined",
                              placeholder: "vyopta_vanrptvwr",
                            },
                            model: {
                              value: _vm.metadata.userRoleMapping,
                              callback: function ($$v) {
                                _vm.$set(_vm.metadata, "userRoleMapping", $$v)
                              },
                              expression: "metadata.userRoleMapping",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { justify: "start" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Dashboard Group Mapping",
                              variant: "outlined",
                              placeholder: "vyopta_vanDbVwr",
                            },
                            model: {
                              value: _vm.metadata.dashboardRoleMapping,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.metadata,
                                  "dashboardRoleMapping",
                                  $$v
                                )
                              },
                              expression: "metadata.dashboardRoleMapping",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Read-only Group Mapping",
                              variant: "outlined",
                              placeholder: "vyopta_vanRptRdr",
                            },
                            model: {
                              value: _vm.metadata.readOnlyRoleMapping,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.metadata,
                                  "readOnlyRoleMapping",
                                  $$v
                                )
                              },
                              expression: "metadata.readOnlyRoleMapping",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showDomainAlias
                    ? _c(
                        "v-row",
                        { attrs: { justify: "start" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "w-25" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Domain Aliases",
                                  variant: "outlined",
                                },
                                model: {
                                  value: _vm.metadata.domainAliases,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.metadata, "domainAliases", $$v)
                                  },
                                  expression: "metadata.domainAliases",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-col", { staticClass: "w-25" }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-actions", [
        _c(
          "button",
          {
            staticClass: "me-4 btn btn-primary",
            attrs: { disabled: !_vm.valid },
            on: { click: _vm.save },
          },
          [_vm._v("Save")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "me-4 btn btn-default", on: { click: _vm.cancel } },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "me-4 btn btn-default",
            on: { click: _vm.deleteMetadata },
          },
          [_vm._v("Delete")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }